import React from 'react';

const About = () => {
  const timelineData = [
    { 
      year: '1985', 
      title: 'Raíces en la apicultura', 
      desc: 'El Sr. Víctor Preciado inicia en la apicultura de la mano de su padre, el Sr. Cipriano Preciado.' 
    },
    { 
      year: '1990', 
      title: 'Abeja Ligustica Italiana', 
      desc: 'Introducimos genética italiana Ligustica para garantizar abejas de mayor calidad y mejor temperamento.' 
    },
    { 
      year: '1995-2000', 
      title: 'Comercialización Regional', 
      desc: 'Nos dedicamos a explotar la miel de abeja y a comercializarla a nivel local y en ocasiones con acopiadores en Guadalajara, dependiendo la cantidad de cosecha.' 
    },
    { 
      year: '2004', 
      title: 'Capacitación Internacional y Genética', 
      desc: 'Se recibió capacitación de alimentación y nutrición de abejas por el apicultor francés Gilles Fert. Control de Varroasis por el apicultor argentino Marcelo del Hoyo. Y de producción de reinas creando una genética adaptada a nuestra zona a partir de las reinas con las que ya contábamos por el apicultor mexicano Roberto Murillo.' 
    },
    { 
      year: '2008', 
      title: 'El Inicio de lo Artesanal', 
      desc: 'El Sr. Víctor Preciado y su esposa, la Sra. Elena Leonor, deciden ir más allá de la apicultura tradicional y toman un curso para fabricar productos artesanales a partir de los derivados de la colmena. Con gran ilusión y dedicación, inician formalmente la creación de cosméticos y productos para la salud, dando vida a su negocio desde la intimidad de su hogar y con un enfoque 100% natural.' 
    },
    { 
      year: '2009', 
      title: 'Nuestro Famoso Tríptico', 
      desc: 'Diseñamos nuestra herramienta educativa icónica para informar sobre los beneficios de cada producto.' 
    },
    { 
      year: '2016', 
      title: 'Presencia en Facebook', 
      desc: 'Abrimos nuestra primera pagina de Facebook para mostrar el día a día de nuestro trabajo con las abejas.' 
    },
    { 
      year: '2020', 
      title: 'Entrega a Domicilio', 
      desc: 'La pandemia nos motiva a entregar a domicilio atendiendote desde nuestras redes sociales para hacer tu peido y recibirlo en tu domicilio.' 
    }, 
    { 
      year: '2021', 
      title: 'Nuestra Vida en Vídeo', 
      desc: 'Comenzamos a grabar el proceso de producción para mostrar lo que hay detrás de nuestro trabajo.' 
    },
    { 
      year: '2022', 
      title: 'Nueva Identidad Visual', 
      desc: 'Rediseñamos nuestro logotipo reflejando nuestra evolución y profesionalismo.' 
    },
    { 
      year: '2025', 
      title: 'Alcance Nacional', 
      desc: 'Consolidamos envíos a toda la república, llevando productos apícolas artesanales a cada rincón del país.' 
    },
    { 
      year: '2026', 
      title: 'Presencia Web Moderna', 
      desc: 'Lanzamos esta plataforma digital para ofrecerte una experiencia completa y profesional. Aquí podrás conocer más sobre nosotros, explorar nuestra galería y comprar nuestros productos.' 
    },
    { 
      year: 'Futuro', 
      title: 'Innovación y Expansión', 
      desc: 'Nos proyectamos hacia una apicultura moderna, donde el uso de la inteligencia artificial nos permita optimizar tanto el cuidado de nuestras colmenas como la forma en que conectamos y comercializamos con nuestros clientes. Seguiremos desarrollando nuevas líneas de productos, implementando santuarios educativos y llevando nuestra miel a nuevos mercados, siempre fieles a nuestra esencia familiar.' 
    },
  ];

  return (
    <section 
      id="about" 
      /* 👇 Margen superior reducido (pt-12) */
      className="pt-12 pb-24 bg-[#FFFBF0] dark:bg-[#1C1B17] transition-colors duration-300 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Encabezado Principal - Texto eliminado y margen inferior reducido */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-6xl font-black text-[#594400] dark:text-[#FFD54F] mb-6 uppercase tracking-tighter">
            Quiénes Somos
          </h2>
          <div className="w-24 h-2 bg-yellow-500 dark:bg-[#FFD54F] mx-auto rounded-full"></div>
        </div>

        {/* Misión y Visión - Ahora más arriba */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-24">
          {/* Misión */}
          <div className="bg-yellow-500 dark:bg-[#2A2821] p-8 md:p-12 rounded-[3rem] border-4 border-white dark:border-[#594400] shadow-xl transition-transform hover:scale-[1.01]">
            <h3 className="text-3xl font-black text-white dark:text-[#FFD54F] mb-4 uppercase">Nuestra Misión</h3>
            <p className="text-white dark:text-[#FFE082]/90 text-lg leading-relaxed font-medium">
              Brindar miel de abeja 100% pura y productos derivados de la más alta calidad a precios accesibles. Como familia, nos dedicamos a conservar la pureza de nuestros procesos artesanales, asegurando al mismo tiempo que cada cliente reciba una atención cálida, rápida y personalizada que convierta su compra en una experiencia excepcional.
            </p>
          </div>

          {/* Visión */}
          <div className="bg-white dark:bg-[#2A2821] p-8 md:p-12 rounded-[3rem] border-2 border-yellow-200 dark:border-[#594400] shadow-sm transition-transform hover:scale-[1.01]">
            <h3 className="text-3xl font-black text-[#594400] dark:text-[#FFD54F] mb-4 uppercase">Nuestra Visión</h3>
            <p className="text-yellow-900 dark:text-[#FFE082]/80 text-lg leading-relaxed font-medium">
              Consolidarnos como un referente en el sector apícola mediante la integración de tecnología innovadora en nuestros procesos de producción y comercialización, evolucionando constantemente sin perder jamás la esencia artesanal y natural que nos define.
            </p>
          </div>
        </div>

        {/* Nuestra Historia */}
        <div className="w-full">
          <h3 className="text-4xl font-black text-[#594400] dark:text-[#FFD54F] mb-16 uppercase tracking-tight text-center">
            Nuestra Historia
          </h3>
          
          <div className="relative w-full py-10">
            <div className="absolute left-12 md:left-1/2 top-0 h-full w-1.5 bg-yellow-400 dark:bg-[#594400] rounded-full transform -translate-x-1/2"></div>

            <div className="space-y-16 md:space-y-24">
              {timelineData.map((item, index) => {
                const isEven = index % 2 === 0;

                return (
                  <React.Fragment key={index}>
                    
                    {item.year === '1985' && (
                      <div className="relative z-20 flex w-full justify-start md:justify-center pl-2 md:pl-0">
                        <div className="bg-yellow-100 dark:bg-[#2A2821] border-2 border-yellow-400 dark:border-[#594400] px-4 md:px-6 py-2 rounded-full shadow-lg">
                          <span className="text-yellow-900 dark:text-[#FFD54F] font-black uppercase tracking-widest text-xs md:text-sm">
                            📖 Antecedentes Familiares
                          </span>
                        </div>
                      </div>
                    )}

                    {item.year === '2008' && (
                      <div className="relative z-20 flex w-full justify-start md:justify-center pl-2 md:pl-0 mt-8 mb-4">
                        <div className="bg-[#F9A825] dark:bg-[#594400] border-2 border-yellow-500 dark:border-[#CA8A04] px-4 md:px-6 py-2 rounded-full shadow-lg">
                          <span className="text-white dark:text-[#FFE082] font-black uppercase tracking-widest text-xs md:text-sm">
                            🚀 Nace el Proyecto
                          </span>
                        </div>
                      </div>
                    )}

                    <div className={`relative flex items-center w-full md:justify-between group ${isEven ? 'md:flex-row-reverse' : 'md:flex-row'}`}>
                      <div className="absolute left-12 md:left-1/2 z-10 transform -translate-x-1/2 flex items-center justify-center">
                        <div 
                          className="flex items-center justify-center text-white dark:text-[#1C1B17] font-black shadow-2xl bg-[#CA8A04] dark:bg-[#FFD54F]
                                   h-24 w-24 text-xs px-1 leading-tight
                                   md:h-32 md:w-32 md:text-base md:px-3
                                   transition-transform duration-300 group-hover:scale-110" 
                          style={{
                            clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)'
                          }}
                        >
                          <span className="text-center">{item.year}</span>
                        </div>
                      </div>

                      <div className="hidden md:block md:w-5/12"></div>

                      <div className={`w-full pl-28 pr-4 md:px-0 md:w-5/12 ${isEven ? 'md:text-right' : 'md:text-left'}`}>
                        <div className={`bg-white dark:bg-[#2A2821] border-2 border-yellow-200 dark:border-[#594400] rounded-[2rem] p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 w-full`}>
                          <h4 className="text-xl md:text-2xl font-black text-[#594400] dark:text-[#FFD54F] mb-3">
                            {item.title}
                          </h4>
                          <p className="text-yellow-900 dark:text-[#FFE082]/80 text-base md:text-lg leading-relaxed font-medium">
                            {item.desc}
                          </p>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;